import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {Form, Input, Button, message} from 'antd';
import {loginUser} from '../store/reducers/thunks/loginUser';
import {store} from "../store/store";
import {clearPendingPromoterForms} from "../store/reducers/formPromoterReducer";
import {clearPendingForms} from "../store/reducers/formReducer";
import '../styles/fonts.css';
import './LoginPage.css';
import packageJson from '../../package.json';

const LoginPage = () => {
    const [messageApi, contextHolder] = message.useMessage();
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const [form] = Form.useForm();

    const handleLogin = async (values) => {
        setLoading(true);
        try {
            await dispatch(loginUser(values)).unwrap();
            store.dispatch(clearPendingForms());
            store.dispatch(clearPendingPromoterForms());
        } catch (error) {
            messageApi.error(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {contextHolder}
            <div className="login-page">
                <img src="/promorena.png" alt="Promorena" className="login-logo" />
                
                <div className="login-left">
                    <div className="login-left-shapes">
                        <div className="login-shape-1"></div>
                        <div className="login-shape-2"></div>
                        <div className="login-shape-3"></div>
                        <div className="login-shape-4"></div>
                    </div>
                    
                    <div className="login-form-container">
                        <div>
                            <h1 className="login-title">Bienvenido</h1>
                            <p className="login-subtitle">Ingresa tus credenciales para continuar</p>
                        </div>

                        <Form form={form} layout="vertical" onFinish={handleLogin}>
                            <Form.Item
                                label={<span style={{color: '#374151', fontWeight: 500}}>Usuario</span>}
                                name="username"
                                rules={[
                                    { required: true, message: 'Ingresa tu usuario' },
                                    { pattern: /^[A-Z0-9]*$/, message: 'Solo letras y números en mayúsculas' },
                                ]}
                            >
                                <Input
                                    placeholder="Usuario"
                                    style={{ height: '48px', fontSize: '16px', fontFamily: "'Fira Code', monospace" }}
                                    onChange={(e) => {
                                        const value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
                                        form.setFieldsValue({ username: value });
                                    }}
                                />
                            </Form.Item>

                            <Form.Item
                                label={<span style={{color: '#374151', fontWeight: 500}}>Contraseña</span>}
                                name="password"
                                rules={[{required: true, message: 'Ingresa tu contraseña'}]}
                            >
                                <Input.Password 
                                    placeholder="Contraseña" 
                                    style={{ height: '48px', fontSize: '16px' }}
                                    styles={{ input: { fontFamily: "'Fira Code', monospace" } }}
                                />
                            </Form.Item>

                            <Form.Item>
                                <Button
                                    type="primary" 
                                    htmlType="submit" 
                                    block
                                    loading={loading}
                                    style={{height: '48px', fontSize: '18px', fontWeight: 600}}
                                >
                                    Iniciar sesión
                                </Button>
                            </Form.Item>
                            
                            <div style={{textAlign: 'right', marginTop: '1rem'}}>
                                <span style={{color: '#9ca3af', fontSize: '14px'}}>v{packageJson.version}</span>
                            </div>
                        </Form>
                    </div>
                </div>

                <div className="login-right">
                    <div className="login-right-shapes">
                        <div className="login-right-shape-1"></div>
                        <div className="login-right-shape-2"></div>
                        <div className="login-right-shape-3"></div>
                        <div className="login-right-shape-4"></div>
                        <div className="login-right-shape-5"></div>
                    </div>
                    
                    <div className="login-icons-grid">
                        <div className="login-icon-wrapper login-icon-4">
                            <div className="login-icon-box">
                                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default LoginPage;
